<template>
  <div class="container">
    <div class="searchBox">
      <common-search-form-wrapper :reset="handleSearchReset">
        <el-form size="mini" :model="searchInfo" ref="form">
          <el-row>
            <el-col :span="8">
              <el-form-item label="学员搜素: " prop="student_id">
                <el-input
                  v-model="searchInfo.student_key_word"
                  placeholder="学员姓名/手机号"
                  @change="handleSearch"
                  clearable
                  @clear="handleSearch"
                  prefix-icon="el-icon-search"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="科目: " prop="subject_id">
                <el-select
                  v-model="searchInfo.subject_id"
                  placeholder="请选择"
                  clearable
                  filterable
                  :filter-method="handleSearchSubjectList"
                  @focus="handleSearchSubjectList('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in subjectList"
                    :key="item.subject_id"
                    :label="item.subject_title"
                    :value="item.subject_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课程名称: " prop="course_id">
                <el-select
                  v-model="searchInfo.course_id"
                  placeholder="请选择"
                  clearable
                  filterable
                  :filter-method="handleSearchCourseList"
                  @focus="handleSearchCourseList('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in courseList"
                    :key="item.course_id"
                    :label="item.title"
                    :value="item.course_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="续费状态: " prop="renew_status">
                <el-radio-group
                  v-model="searchInfo.renew_status"
                  @change="handleSearch"
                  size="mini"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="2">已续费</el-radio-button>
                  <el-radio-button :label="1">未续费</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="记录时间: ">
                <!-- <el-date-picker
                  v-model="searchInfo.record_time"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  clearable
                  @change="handleSearch"
                >
                </el-date-picker> -->
                <common-date-range-selector
                  v-model="searchInfo.record_time"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  clearable
                  @change="handleSearch"
                >
                </common-date-range-selector>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="续费分类: " prop="renew_type">
                <el-radio-group
                  v-model="searchInfo.renew_type"
                  @change="handleSearch"
                  size="mini"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">正常</el-radio-button>
                  <el-radio-button :label="2">提前</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="业务类型: " prop="order_type">
                <el-radio-group
                  v-model="searchInfo.order_type"
                  @change="handleSearch"
                  size="mini"
                >
                  <el-radio-button :label="0">全部</el-radio-button>
                  <el-radio-button :label="1">购课</el-radio-button>
                  <el-radio-button :label="3">转课</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="课程顾问: " prop="course_adviser">
                <common-staff-pull-down
                  :originId.sync="searchInfo.course_adviser"
                  :defaultSelected.sync="searchInfo.course_adviser_list"
                  :jobIds="[3]"
                  @change="handleSearch"
                  :multiple="true"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="教务老师: " prop="staff_teacher_id">
                <common-staff-pull-down
                  :originId.sync="searchInfo.staff_teacher_id"
                  :defaultSelected.sync="searchInfo.staff_teacher_list"
                  :jobIds="[2]"
                  @change="handleSearch"
                  :multiple="true"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课程老师: " prop="teacher_id">
                <common-staff-pull-down
                  :originId.sync="searchInfo.teacher_id"
                  :defaultSelected.sync="searchInfo.teacher_list"
                  :jobIds="[1]"
                  @change="handleSearch"
                  :multiple="true"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="课程类型: " prop="course_type">
                <el-radio-group
                  v-model="searchInfo.course_type"
                  @change="handleSearch"
                  size="mini"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">1vN</el-radio-button>
                  <el-radio-button :label="2">1v1</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="缴费时间: ">
                <common-date-range-selector
                  v-model="searchInfo.renew_time"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  clearable
                  @change="handleSearch"
                >
                </common-date-range-selector>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
    </div>
    <div class="statistics">
      <p style="color: #5c5d5e">
        续费总计: {{ statisticsInfo.total_amount }}元, 提前续费总计:
        {{ statisticsInfo.ahead_amount }}元, 正常续费总计
        {{ statisticsInfo.normal_amount }}元, 续费人数:
        {{ statisticsInfo.student_num }}人
      </p>
      <el-popover
        placement="top"
        width="190"
        popper-class="followuppopover"
        trigger="hover"
      >
        <p class="tipck">
          续费总计 = 提前续费总计 + 正常续费总计，不包含已废除订单；
        </p>
        <div class="question" slot="reference">
          <div>?</div>
        </div>
      </el-popover>
    </div>
    <el-table
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      :default-sort="{ prop: 'log_time', order: 'descending' }"
      @sort-change="clickSort"
    >
      <el-table-column prop="student.name" label="学员姓名">
        <template slot-scope="scope">
          <div class="mwow-green cu-po" @click="goStudentDetail(scope.row)">
            {{ scope.row.student.name || "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subject.subject_title"
        label="科目"
      ></el-table-column>
      <el-table-column prop="course.title" label="课程名称"></el-table-column>
      <el-table-column prop="course.course_type" label="课程类型">
        <template slot-scope="scope">
          <div>
            {{ scope.row.course.course_type === 1 ? "1vN" : "1v1" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="130"
        prop="log_time"
        label="记录时间"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column>
        <template slot="header">
          <div class="selfheader">
            <div>提醒课时</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">进入记录列表时，续费规则设定的课时数；</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.condition }}</div>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot="header">
          <div class="selfheader">
            <div>记录课时</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">进入记录列表时，学员课程剩余课时数；</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.remain }}</div>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot="header">
          <div class="selfheader">
            <div>剩余课时</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">学员课程剩余课时数；</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.student_course_account.usable_number }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="renew_type" label="续费分类">
        <template slot="header">
          <div class="selfheader">
            <div>续费分类</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">
                正常：达到设定续费提醒条件需续费课程；<br />
                提前：未达到设定续费条件，已提前完成续费课程；
              </p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.renew_type === 1 ? "正常" : "提前" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="order_type" label="业务类型">
        <template slot="header">
          <div class="selfheader">
            <div>业务类型</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p class="tipck">学员订单的业务类型:购课/转课</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.order_type === 3 ? "转课" : "购课" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="follow_staff.name" label="课程顾问">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.follow_staff === null
                ? "-"
                : scope.row.follow_staff.name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="edu_teacher.name" label="教务老师">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.edu_teacher === null ? "-" : scope.row.edu_teacher.name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="课程老师">
        <template slot-scope="scope">
          <div
            v-if="scope.row.teacher_list && scope.row.teacher_list.length > 0"
          >
            {{
              scope.row.teacher_list
                .map((it) => {
                  return it.name;
                })
                .join("、")
            }}
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="续费状态">
        <template slot-scope="scope">
          <div>
            {{ scope.row.renew_status === 1 ? "未续费" : "已续费" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订单号">
        <template slot-scope="scope">
          <div
            :class="scope.row.order_no === '' ? '' : 'mwow-green cu-po'"
            @click="goOrderDetail(scope.row)"
          >
            {{ scope.row.order_no || "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="续费金额">
        <template slot-scope="scope">
          <div>¥&nbsp;{{ scope.row.renew_amount || "-" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="续费时间"
        prop="renew_time"
        width="130"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { getSeleSubjectsList, getSelectCourseList } from "@/api/globalSearch";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import { renewRecordListApi, renewRecordCountApi } from "@/api/renewal";
import { dateFormat } from "@/utils/timeFormat";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import { mixin } from "@/mixin/tabPageInfoMixin";
export default {
  props: ["visible"],
  mixins: [mixin],
  components: {
    commonStaffPullDown,
    CommonSearchFormWrapper,
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        student_key_word: "",
        course_type: -1,
        record_time: [],
        renew_time: [],
        renew_type: -1,
        renew_status: -1,
        sort_type: "desc",
        sort_field: "",
        teacher_id: [],
        teacher_list: [],
        staff_teacher_id: [],
        staff_teacher_list: [],
        course_adviser: [],
        course_adviser_list: [],
        order_type: 0,
      },
      subjectList: [],
      courseList: [],
      adviserList: [],
      staffTeacherList: [],
      teacherList: [],
      tableData: [],
      statisticsInfo: {},
      pageSize: 10,
      page: 1,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  created() {
    // 来自续费数据页面
    if (this.$route.query.from === "renewal") {
      this.searchInfo.record_time[0] = this.$route.query.s_time;
      this.searchInfo.record_time[1] = this.$route.query.e_time;
      if (this.$route.query.val === "course_renewed_count") {
        this.searchInfo.renew_status = 2;
      } else if (this.$route.query.val === "renew_amount") {
        this.searchInfo.renew_type = 1;
        this.searchInfo.renew_status = 2;
      } else if (this.$route.query.val === "pre_renew_amount") {
        this.searchInfo.renew_type = 2;
        this.searchInfo.renew_status = 2;
      }
      if (this.$route.query.key === "staff") {
        this.searchInfo.course_adviser = [Number(this.$route.query.id)];
        this.searchInfo.course_adviser_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "edu_teacher") {
        this.searchInfo.staff_teacher_id = [Number(this.$route.query.id)];
        this.searchInfo.staff_teacher_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "teacher") {
        this.searchInfo.teacher_id = [Number(this.$route.query.id)];
        this.searchInfo.teacher_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "course") {
        this.searchInfo.course_id = Number(this.$route.query.id);
        this.searchInfo.courseList = [
          {
            course_id: Number(this.$route.query.id),
            title: this.$route.query.label,
          },
        ];
      }
    } else {
      let pageCache = sessionStorage.getItem(
        "teach-renew-manage-record-page-cache"
      );
      if (pageCache) {
        let pageCacheJSON = JSON.parse(pageCache);
        if (pageCacheJSON.search_info) {
          this.searchInfo = pageCacheJSON.search_info;
        }
      }
    }
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleSearchSubjectList(v) {
      getSeleSubjectsList({
        page: 1,
        page_size: 1000,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.subjectList = res.data.list;
        }
      });
    },
    handleSearchCourseList(v) {
      getSelectCourseList({
        page: 1,
        page_size: 1000,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
    },
    getList(val) {
      const data = {
        page: val.page,
        page_size: val.page_size,
      };
      if (this.searchInfo.student_key_word) {
        data.key_word = this.searchInfo.student_key_word;
      }
      if (this.searchInfo.subject_id) {
        data.subject_ids = [this.searchInfo.subject_id];
      }
      if (this.searchInfo.course_id) {
        data.course_ids = [this.searchInfo.course_id];
      }
      if (this.searchInfo.course_type !== -1) {
        data.course_type = this.searchInfo.course_type;
      }
      if (this.searchInfo.record_time) {
        data.log_start_date = this.searchInfo.record_time[0];
        data.log_end_date = this.searchInfo.record_time[1];
      }
      if (this.searchInfo.renew_type !== -1) {
        data.renew_type = this.searchInfo.renew_type;
      }
      if (this.searchInfo.course_adviser) {
        data.follow_staff_ids = this.searchInfo.course_adviser;
      }
      if (this.searchInfo.staff_teacher_id) {
        data.edu_teacher_ids = this.searchInfo.staff_teacher_id;
      }
      if (this.searchInfo.teacher_id) {
        data.teacher_ids = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.renew_status !== -1) {
        data.renew_status = this.searchInfo.renew_status;
      }
      if (this.searchInfo.renew_time) {
        data.renew_start_date = this.searchInfo.renew_time[0];
        data.renew_end_date = this.searchInfo.renew_time[1];
      }
      if (this.searchInfo.sort_type) {
        data.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field) {
        data.sort_field = this.searchInfo.sort_field;
      }
      if (this.searchInfo.order_type) {
        data.order_type = this.searchInfo.order_type;
      }
      sessionStorage.setItem(
        "teach-renew-manage-record-page-cache",
        JSON.stringify({
          search_info: this.searchInfo,
          page: data.page,
          page_size: data.page_size,
        })
      );
      if (val.count === 1) {
        renewRecordListApi(data).then((res) => {
          if (res.error_code === 0) {
            res.data.list.map((it) => {
              if (it.log_time !== 0) {
                it.log_time = dateFormat(
                  "YYYY-mm-dd HH:MM",
                  it.log_time * 1000
                );
              } else {
                it.log_time = "-";
              }
              if (it.renew_time !== 0) {
                it.renew_time = dateFormat("YYYY-mm-dd", it.renew_time * 1000);
              } else {
                it.renew_time = "-";
              }
            });
            this.page = res.data.page;
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
      } else {
        renewRecordListApi(data).then((res) => {
          if (res.error_code === 0) {
            res.data.list.map((it) => {
              if (it.log_time !== 0) {
                it.log_time = dateFormat(
                  "YYYY-mm-dd HH:MM",
                  it.log_time * 1000
                );
              } else {
                it.log_time = "-";
              }
              if (it.renew_time !== 0) {
                it.renew_time = dateFormat("YYYY-mm-dd", it.renew_time * 1000);
              } else {
                it.renew_time = "-";
              }
            });
            this.tableData = res.data.list;
            this.total = res.data.total;
            this.page = res.data.page;
          }
        });
        renewRecordCountApi(data).then((res) => {
          if (res.error_code === 0) {
            res.data.total_amount =
              res.data.total_amount === "0.00" ? "0" : res.data.total_amount;
            res.data.normal_amount =
              res.data.normal_amount === "0.00" ? "0" : res.data.normal_amount;
            res.data.ahead_amount =
              res.data.ahead_amount === "0.00" ? "0" : res.data.ahead_amount;
            this.statisticsInfo = res.data;
          }
        });
      }
    },
    clickSort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: 1,
        page_size: this.pageSize,
        count: 1,
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    goStudentDetail(v) {
      this.mixinSavePageInfo("renewRecordSearch");
      this.$router.push({
        name: "studyDetails",
        query: {
          id: v.student_id,
        },
      });
    },
    goOrderDetail(v) {
      this.mixinSavePageInfo("renewRecordSearch");
      if (v.order_item_id) {
        this.$router.push({
          name: "orderManageDetail",
          query: {
            sid: v.student_id,
            id: v.order_id,
          },
        });
      }
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
        count: 1,
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList({
        page: e,
        page_size: this.pageSize,
        count: 1,
      });
    },
    handleSearchReset() {
      this.searchInfo = {
        student_key_word: "",
        course_type: -1,
        record_time: [],
        renew_time: [],
        renew_type: -1,
        renew_status: -1,
        sort_type: "desc",
        sort_field: "",
        teacher_id: [],
        teacher_list: [],
        staff_teacher_id: [],
        staff_teacher_list: [],
        course_adviser: [],
        course_adviser_list: [],
      };
      this.handleSearch();
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 10px 10px 10px;
  border-radius: 4px;
  overflow: hidden;
}
/deep/.el-form {
  .el-form-item {
    margin-right: 58px;
    .el-form-item__label {
      width: 65px;
      text-align: left;
    }
    .el-form-item__content {
      display: flex;
      .el-select,
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
.statistics {
  height: 30px;
  line-height: 30px;
  display: flex;
  background-color: #fff7e9;
  align-items: center;
  padding-left: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  .popo-sp {
    margin-left: 10px;
    width: 15px !important;
    height: 15px !important;
    border-radius: 50%;
    background-color: #bebfc0;
    text-align: center;
    line-height: 16px;
    color: #ffffff;
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
.selfheader {
  display: flex;
  align-items: center;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
/deep/ .el-radio-group {
  display: flex;
}
</style>
